import { makeStyles } from '@material-ui/core/styles'

const drawerWidth = 240

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex'
  },
  appBar: {
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen
    }),
    boxShadow: '0px 0px 0px #000'
  },
  appBarShift: {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    boxShadow: '0px 0px 0px #000',
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen
    })
  },
  menuButton: {
    color: '#fff',
    marginRight: 36
  },
  hide: {
    display: 'none'
  },
  drawer: {
    width: drawerWidth,
    flexShrink: 0,
    whiteSpace: 'nowrap'
  },
  drawerOpen: {
    width: drawerWidth,
    backgroundColor: '#30287b',
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen
    })
  },
  drawerClose: {
    backgroundColor: '#30287b',
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen
    }),
    overflowX: 'hidden',
    width: theme.spacing(7) + 1,
    [theme.breakpoints.up('sm')]: {
      width: theme.spacing(9) + 1
    }
  },
  toolbar: {
    display: 'flex',
    height: 130,
    backgroundColor: '#ece5fe',
    color: '#30287b',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',
    justifyItems: 'center',
    fontFamily: ['Montserrat', 'sans-serif'],
    // padding: theme.spacing(0, 1),
    ...theme.mixins.toolbar
  },

  content: {
    flexGrow: 1,
    padding: theme.spacing(3),
    transition: theme.transitions.create('margin', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen
    }),
    marginLeft: 0
  },
  contentShift: {
    transition: theme.transitions.create('margin', {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen
    }),
    marginLeft: 0
  },

  toolbarInfoPage: {
    flex: 1,
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
    '& h1': {
      flex: 1,
      fontFamily: ['Matrice', 'sans-serif']
    },
    '& .c-header__tab__wrapper': {
      marginBottom: '-27px'
    },
    '& .c-header__top': {
      flex: 1,
      width: '100%',
      display: 'flex',
      alignItems: 'center'
    },
    '& .c-header__bottom': {
      flex: 1,
      width: '100%',
      display: 'flex'
    }
  },
  infoPageButtons: {
    display: 'fex'
  }
}))

export default useStyles
